import { EnumValues } from '@/services/types/EnumValues';
import { TransactionSignEnum } from '@/services/types/TransactionData';
import { isCredit } from './isCredit';

export const getAmountSign = (sign: EnumValues<typeof TransactionSignEnum>) => {
  return isCredit(sign) ? '+' : '-';
};
